import React from "react";

import { StyledSVG } from "../StyledIcon";

export const PerformanceIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M12.2208 14.3562C12.9832 13.8978 13.639 13.2818 14.1442 12.5496C14.6495 11.8173 14.9926 10.9856 15.1506 10.1101C15.3086 9.23458 15.2779 8.33542 15.0605 7.47274C14.8431 6.61005 14.4441 5.80372 13.89 5.10765C13.3359 4.41158 12.6397 3.84182 11.8477 3.43646C11.0558 3.0311 10.1864 2.79948 9.29778 2.7571C8.40913 2.71471 7.52168 2.86253 6.69475 3.19067C5.86782 3.51881 5.12047 4.01972 4.50268 4.65989"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.1466 6.80906C2.66501 8.0957 2.62076 9.50518 3.02071 10.8195"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.47941 13.3159C4.98343 13.8438 5.57602 14.2794 6.23032 14.6028"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.04077 9.07516L12 14"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
